import { Box, Typography, Paper } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AgreementScrollToTop } from "../AgreementLayout";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import GavelIcon from "@mui/icons-material/Gavel";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

const linkItems = [
    { to: "/kvkk-uzaktan-saglik-bilgilendirme", key: "contracts_link_kvkk_remote_health" },
    { to: "/uzaktan-saglik-sunumu-bilgilendirme", key: "contracts_link_remote_terms" },
    { to: "/uzaktan-saglik-bilgilendirme", key: "contracts_link_remote_health_legacy" },
    { to: "/uzaktan-saglik-mesafeli-satis-sozlesmesi", key: "contracts_link_remote_distance_sales" },
    { to: "/uyelik-ve-hizmet-sozlesmesi", key: "contracts_link_membership" },
    { to: "/kullanicilar-aydinlatma-metni", key: "contracts_link_clarification" },
    { to: "/kvkk-politikasi", key: "contracts_link_kvkk_policy" },
    { to: "/kisisel-pazarlama-acik-riza-metni", key: "contracts_link_marketing" },
    { to: "/kullanim-kosullari", key: "contracts_link_terms" },
    { to: "/gizlilik-politikasi", key: "contracts_link_privacy" },
];

const Sozlesmeler = () => {
    const { t } = useTranslation();
    const visibleLinkItems = linkItems.slice(0, 3);
    return (
        <Box sx={{ width: "100%", maxWidth: 800, mx: "auto", px: { xs: 2, md: 4 }, py: { xs: 3, md: 5 } }}>
            <AgreementScrollToTop />

            <Box sx={{
                background: "linear-gradient(135deg, #0D9488 0%, #14b8a6 50%, #5EEAD4 100%)",
                borderRadius: "16px 16px 0 0",
                px: { xs: 3, md: 4 },
                py: { xs: 3, md: 4 },
                display: "flex",
                alignItems: "center",
                gap: 2,
            }}>
                <GavelIcon sx={{ color: "rgba(255,255,255,0.85)", fontSize: 32 }} />
                <Box>
                    <Typography variant="h5" component="h1" fontWeight={700} color="#fff">
                        {t("contracts_page_title")}
                    </Typography>
                    <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.8)", mt: 0.5 }}>
                        {t("contracts_page_subtitle")}
                    </Typography>
                </Box>
            </Box>

            <Paper
                elevation={0}
                sx={{
                    border: "1px solid",
                    borderColor: "divider",
                    borderTop: 0,
                    borderRadius: "0 0 16px 16px",
                    overflow: "hidden",
                }}
            >
                {visibleLinkItems.map((item, idx) => (
                    <Box
                        key={item.to}
                        component={RouterLink}
                        to={item.to}
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                            px: { xs: 2.5, md: 3 },
                            py: 2,
                            textDecoration: "none",
                            color: "text.primary",
                            borderTop: idx === 0 ? "none" : "1px solid",
                            borderColor: "divider",
                            transition: "background-color 0.15s, color 0.15s",
                            "&:hover": {
                                bgcolor: "rgba(13, 148, 136, 0.06)",
                                "& .link-icon": { color: "#0D9488" },
                                "& .link-text": { color: "#0D9488" },
                                "& .link-arrow": { color: "#0D9488", transform: "translateX(3px)" },
                            },
                        }}
                    >
                        <DescriptionOutlinedIcon
                            className="link-icon"
                            sx={{ color: "text.disabled", fontSize: 20, flexShrink: 0, transition: "color 0.15s" }}
                        />
                        <Typography
                            className="link-text"
                            variant="body2"
                            sx={{ fontWeight: 500, flex: 1, transition: "color 0.15s" }}
                        >
                            {t(item.key)}
                        </Typography>
                        <ChevronRightIcon
                            className="link-arrow"
                            sx={{ color: "text.disabled", fontSize: 20, flexShrink: 0, transition: "color 0.15s, transform 0.15s" }}
                        />
                    </Box>
                ))}
            </Paper>
        </Box>
    );
};

export default Sozlesmeler;
